export const ValidationsService = (props) => {
  // ERROR VARIABLES

  let phoneErr = "";
  let firstNameErr = "";
  let bioErr = "";
  let emailErr = "";
  let dobErr = "";
  let stateErr = "";
  let specialityErr = "";
  let certificatesErr = "";
  let id_proofsErr = "";
  let languageErr = "";
  let licenceErr = "";
  let availabilityErr = "";
  let pricingErr = "";
  let queryErr = "";
  let nameErr = "";
  let lastNameErr = "";
  let cvvErr = "";
  let monthErr = "";
  let yearErr = "";
  let cardNumErr = "";
  let license_numberErr = "";

  let validationsRes = {};

  // REGEX VARIABLES

  const nameRegex = /^[a-zA-Z ]{2,}$/;
  const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;
  const PassRegex =
    /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@#$!%*^?&])[A-Za-z\d$@$!%*^?#&].{7,}/;
  const urlRegex =
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
  const phoneRegex =
    /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;

  // PHONE

  if (props?.phone !== undefined) {
    const PHONE = props.phone.trim();
    if (!PHONE) {
      phoneErr = "Phone number required";
    } else if (!phoneRegex.test(PHONE)) {
      phoneErr = "Phone no. must contain 10 to 12 digits.";
    }
    validationsRes = { ...validationsRes, phoneErr };
  }

  //FIRST NAME

  if (props?.firstName !== undefined) {
    const NAME = props.firstName.trim();
    if (!NAME) {
      firstNameErr = "First name required";
    }
    validationsRes = { ...validationsRes, firstNameErr };
  }
  // NAME

  if (props?.name !== undefined) {
    const NAME = props.name.trim();
    if (!NAME) {
      nameErr = "Name is required";
    }
    validationsRes = { ...validationsRes, nameErr };
  }

  // LAST NAME

  if (props?.last_name !== undefined) {
    const NAME = props.last_name.trim();
    if (!NAME) {
      lastNameErr = "Last name is required";
    }
    validationsRes = { ...validationsRes, lastNameErr };
  }

  //FIRST NAME

  if (props?.bio !== undefined) {
    const BIO = props.bio.trim();
    if (!BIO) {
      bioErr = "Bio is required";
    }
    validationsRes = { ...validationsRes, bioErr };
  }

  // CVV

  if (props?.cvv !== undefined) {
    const CVV = props.cvv.trim();
    if (!CVV) {
      cvvErr = "Cvv is required";
    }
    validationsRes = { ...validationsRes, cvvErr };
  }

  // CARD NUM

  if (props?.cardNum !== undefined) {
    const CARD_NUM = props.cardNum.trim();
    if (!CARD_NUM) {
      cardNumErr = "Card number is required";
    }
    validationsRes = { ...validationsRes, cardNumErr };
  }

  // MONTH

  if (props?.month !== undefined) {
    const MONTH = props.month.trim();
    if (!MONTH) {
      monthErr = "Month is required";
    }
    validationsRes = { ...validationsRes, monthErr };
  }

  // MONTH

  if (props?.year !== undefined) {
    const YEAR = props.year.trim();
    if (!YEAR) {
      yearErr = "Year is required";
    }
    validationsRes = { ...validationsRes, yearErr };
  }
  // DOB

  if (props?.dob !== undefined) {
    const DOB = props.dob.trim();
    if (!DOB) {
      dobErr = "Date of birth is required";
    }
    validationsRes = { ...validationsRes, dobErr };
  }

  // STATE

  if (props?.state !== undefined) {
    const STATE = props.state.length > 0;
    if (!STATE) {
      stateErr = "State is required";
    }
    validationsRes = { ...validationsRes, stateErr };
  }
  // QUERY

  if (props?.query !== undefined) {
    const QUERY = props.query.trim();
    if (!QUERY) {
      queryErr = "Query is required";
    }
    validationsRes = { ...validationsRes, queryErr };
  }

  // SPECIALITY

  if (props?.speciality !== undefined) {
    const SPECIALITY = props.speciality.length;
    if (!SPECIALITY) {
      specialityErr = "Speciality is required";
    }
    validationsRes = { ...validationsRes, specialityErr };
  }

  //LICENSE NUMBER

  if (props?.license_number !== undefined) {
    const LICENSE_NUM = props.license_number.trim();
    if (!LICENSE_NUM) {
      license_numberErr = "License number is required";
    }
    validationsRes = { ...validationsRes, license_numberErr };
  }

  // CERTIFICATES

  if (props?.certificates !== undefined) {
    const CERTIFICATES = props.certificates.length > 0;
    if (!CERTIFICATES) {
      certificatesErr = "Atleast one certificate required";
    }
    validationsRes = { ...validationsRes, certificatesErr };
  }

  // LICENCE

  if (props?.licence !== undefined) {
    const LICENCE = props.licence.length > 0;
    if (!LICENCE) {
      licenceErr = "Atleast one licence required";
    }
    validationsRes = { ...validationsRes, licenceErr };
  }

  // ID_PROOF

  if (props?.id_proofs !== undefined) {
    const ID_PROOF = props.id_proofs.length > 0;
    if (!ID_PROOF) {
      id_proofsErr = "Atleast one ID required";
    }
    validationsRes = { ...validationsRes, id_proofsErr };
  }

  // EMAIL

  if (props?.email !== undefined) {
    const EMAIL = props.email.trim();
    if (!EMAIL) {
      emailErr = "Email is required";
    } else if (!emailRegex.test(EMAIL)) {
      emailErr = "Please fill correct email address";
    }
    validationsRes = { ...validationsRes, emailErr };
  }

  // LANGUAGE

  if (props?.language !== undefined) {
    const LANGUAGE = props.language.length;
    if (!LANGUAGE) {
      languageErr = "Language is required";
    }
    validationsRes = { ...validationsRes, languageErr };
  }

  // AVAILABILITY

  if (props?.availability !== undefined) {
    const AVAILABILITY = props.availability.some(
      (item) => item.checked == true
    );
    if (!AVAILABILITY) {
      availabilityErr = "Atleast one day availability required";
    }
    validationsRes = { ...validationsRes, availabilityErr };
  }

  // PRICING

  if (props?.pricing !== undefined) {
    const PRICING2 = props.pricing.some(
      (item) =>
        (item.checked == true && item.price == "") ||
        (item.checked == true && Number(item.price) < 1)
    );
    const PRICING = props.pricing.some(
      (item) =>
        item.checked == true && item.price != "" && Number(item.price) > 0
    );
    if (PRICING2) {
      pricingErr = "Selected slot should not be empty";
    } else if (!PRICING) {
      pricingErr = "Atleast one pricing slot required";
    }
    validationsRes = { ...validationsRes, pricingErr };
  }

  return validationsRes;
};
